//import configureStore  from './store';
//import authActions from '@iso/redux/auth/actions';

export default () =>
  new Promise(() => {
   // configureStore.store.dispatch(authActions.checkAuthorization());
  });
